// On In Two — ultra-light cart icon persistence
(() => {
  const SRC = "https://cdn.shopify.com/s/files/1/0649/7170/2351/files/cart_image.jpg?v=1757782737";
  const IMG_HTML = `<img src="${SRC}" alt="Cart" class="onintwo-cart-img" width="38" height="38" loading="eager">`;

  let mo; // MutationObserver (scoped)

  const isCorrectIcon = (wrap) => {
    const img = wrap?.querySelector('img.onintwo-cart-img');
    return !!img && img.getAttribute('src') === SRC;
  };

  const applyIconIfNeeded = () => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return false;
    const wrap = bubble.querySelector('.header__cart-icon');
    if (!wrap) return false;

    if (!isCorrectIcon(wrap)) {
      wrap.innerHTML = IMG_HTML;   // Only write when needed
    }
    return true;
  };

  const observeBubbleParent = () => {
    const bubble = document.getElementById('cart-icon-bubble');
    const parent = bubble?.parentNode;
    if (!parent) return;

    mo?.disconnect();
    mo = new MutationObserver((muts) => {
      // Only react if the cart bubble changed
      for (const m of muts) {
        if ([...m.addedNodes, ...m.removedNodes].some(n =>
          n?.nodeType === 1 && (n.id === 'cart-icon-bubble' || n.querySelector?.('#cart-icon-bubble'))
        )) {
          applyIconIfNeeded();
          break;
        }
      }
    });

    mo.observe(parent, { childList: true }); // watch only direct children
  };

  const init = () => {
    if (!applyIconIfNeeded()) return;  // cart link not on this page
    observeBubbleParent();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Cart/section events (cheap fallbacks)
  ['cart:updated','cart:refresh','shopify:section:load'].forEach(evt =>
    document.addEventListener(evt, applyIconIfNeeded)
  );
})();
